import { AutoColorDiscoveryExperience } from '@/services/settingsService';

export const autoColorDiscoveryExperienceValue = 'auto_color_discovery';

/* Janus experiment gate: `disabled` for control/everyone, `auto_color_discovery`
 * only for the segmented treatment, so the spotlight activates only when the
 * visitor is segmented into the experiment. */
export const isAutoColorDiscoveryEnabled = (
  value: AutoColorDiscoveryExperience | undefined
): boolean => value === autoColorDiscoveryExperienceValue;
